import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";

// レイアウトのスタイル
const StyledContainer = styled(Container)({
  backgroundColor: "#fff",
  padding: "40px",
  borderRadius: "8px",
  boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
  textAlign: "center",
});

const ContactForm = () => {
  return (
    <Box sx={{ py: 6, bgcolor: "#f7f7f7" }}>
      {/* Googleフォームの埋め込み */}
      <Box sx={{ overflow: "hidden", maxWidth: "100%", height: "1808px" }}>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSe_NV_uDSqUALdG3_e8a4zORkWrCB_HVfRdlOr5yGJh-Nu0BA/viewform?embedded=true"
          width="100%"
          height="1808"
          frameBorder="0"
          marginHeight={0}
          marginWidth={0}
          title="お問い合わせフォーム"
          style={{ border: 0 }}
        >
          読み込んでいます…
        </iframe>
      </Box>
    </Box>
  );
};

const RecruitSection = () => (
  <Box sx={{ py: 10, bgcolor: "#1D1D1D", color: "white" }}>
    <Container maxWidth="lg" sx={{ textAlign: "center" }}>
      <Typography variant="h2" sx={{ fontWeight: "bold" }}>
        Recruit
      </Typography>
      <Typography variant="h4" sx={{ my: 3, fontWeight: "bold" }}>
        規格外の挑戦を、
        <br />
        最高の仲間と共に。
      </Typography>
      <Typography sx={{ mb: 4 }}>
        私たちは、既成概念を常に破壊したいと考えています。
      </Typography>
      <Button
        variant="contained"
        size="large"
        sx={{ bgcolor: "#673ab7", "&:hover": { bgcolor: "#5e35b1" } }}
      >
        View All Posts
      </Button>
    </Container>
  </Box>
);

const App = () => (
  <>
    <ContactForm />
    {/* <RecruitSection /> */}
  </>
);

export default App;
